import React, { useState, useEffect, useRef } from 'react';
import { Link, NavLink } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Whatsapp from './Whatsapp';

function Cards() {
    const [yearsExperience, setYearsExperience] = useState(0);
    const [happyClients, setHappyClients] = useState(0);
    const [projectsDone, setProjectsDone] = useState(0);
    const [recentClients, setRecentClients] = useState(0);

    const cardsRef = useRef(null);

    const counterAnimation = (finalValue, setValue, duration) => {
        const increment = finalValue / (duration / 50);
        let current = 0;

        const interval = setInterval(() => {
            current += increment;
            if (current >= finalValue) {
                clearInterval(interval);
                setValue(finalValue);
            } else {
                setValue(Math.ceil(current));
            }
        }, 50);
    };

    useEffect(() => {
        AOS.init({
            duration: 1000,
            once: false, // Ensures animation repeats every time the section is in view
        });

        const observer = new IntersectionObserver(
            (entries) => {
                const entry = entries[0];
                if (entry.isIntersecting) {
                    counterAnimation(15, setYearsExperience, 1500);
                    counterAnimation(2000, setHappyClients, 1500);
                    counterAnimation(20, setProjectsDone, 1500);
                    counterAnimation(800, setRecentClients, 1500);
                } else {
                    setYearsExperience(0);
                    setHappyClients(0);
                    setProjectsDone(0);
                    setRecentClients(0);
                }
            },
            {
                threshold: 0.5,
            }
        );

        if (cardsRef.current) {
            observer.observe(cardsRef.current);
        }

        return () => {
            if (cardsRef.current) {
                observer.unobserve(cardsRef.current);
            }
        };
    }, []);

    return (
        <>
            <div className="why-container" ref={cardsRef}>
                <div className="why-head">
                    <div data-aos="fade-up">WHY</div>
                    <div data-aos="fade-up" data-aos-delay="200">CHOOSE</div>
                    <div className="us" data-aos="fade-left" data-aos-delay="400">
                        <a className="circle">
                            &#8594;
                        </a>
                        <span className="inner-us">US?</span>
                    </div>
                </div>

                <div className="stats-section">
                    <div className="stat-box box1" data-aos="fade-up" data-aos-delay="600">
                        <h2>{yearsExperience}+</h2>
                        <p>years of industry experience</p>
                    </div>
                    <div className="stat-box box2" data-aos="fade-up" data-aos-delay="800">
                        <h2>{happyClients}+</h2>
                        <p>Happy Clients</p>
                    </div>
                    <div className="stat-box box3" data-aos="fade-up" data-aos-delay="900">
                        <h2>{projectsDone}+</h2>
                        <p>Projects Done</p>
                    </div>
                    <div className="stat-box highlight-box box3" data-aos="fade-up" data-aos-delay="1000">
                        <h2>{recentClients}+</h2>
                        <p>Recent Clients</p>
                    </div>
                </div>
            </div>

            <Whatsapp />
        </>
    );
}

export default Cards;
